<template>
  <div
    class="margin-top-s"
    data-section="pricing-policy"
    data-auto="pricing-policy"
  >
    <label
      class="label margin-top-xs block"
    > {{ badge.header }} </label>

    <button
      v-show="!showViewMore"
      ref="viewMore"
      class="view-more-button link-sm margin-bottom-m"
      :aria-expanded="showViewMore"
      @click="toggleView"
    >
      View More
    </button>

    <template v-if="showViewMore">
      <p
        class="regular margin-top-xs"
        data-el="product-dimensions"
      >
        {{ badge.rebateInfo?.qualifyText }}
      </p>
      <p
        class="regular margin-top-xxs"
        data-el="product-dimensions"
      >
        {{ badge.rebateInfo?.rebateInfoText }}
      </p>
      <a
        class="button secondary rebate-button margin-top-s"
        rel="noopener noreferrer"
        role="button"
        target="_blank"
        :href="badge.rebateInfo?.rebateformLink"
      >
        Get Rebate
      </a>
    </template>
    <button
      v-show="showViewMore"
      ref="viewLess"
      class="view-less-button link-sm margin-bottom-s block"
      :aria-expanded="showViewMore"
      :aria-label="`View Less, button. Expanded content: ${badge.legalDisclaimer}`"
      @click="toggleView"
    >
      View Less
    </button>
    <p
      v-for="address in badge.rebateInfo?.mailAddress"
      :key="address"
    >
      {{ address }}
    </p>
  </div>

  <hr class="divider gray-background expanded margin-top-z margin-bottom-z">
</template>

<script setup>
import { nextTick, ref } from 'vue';

defineProps({
  badge: {
    /** @type import('vue').PropType<Badge> */
    type: Object,
    required: true,
  },
});

const showViewMore = ref(false);
const viewMore = ref(null);
const viewLess = ref(null);

const toggleView = () => {
  showViewMore.value = !showViewMore.value;
  nextTick(() => {
    if (!showViewMore.value) viewMore.value?.focus();
    else viewLess.value?.focus();
  });
};
</script>

<style scoped>
  @import "~settingSCSS";

  .block {
    display: block;
  }
</style>
